import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import Reveal from "@/components/feature/Reveal";
import { getArticlesByCategory, hotArticles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function HotAndTopicsSection() {
  const hot = hotArticles.slice(0, 6);

  return (
    <section
      aria-labelledby="hot-heading"
      className="w-full border-b border-background-200 bg-background-50"
    >
      <div className="mx-auto grid w-full max-w-[1400px] grid-cols-1 gap-12 px-4 py-14 md:px-8 md:py-16 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <div className="flex items-end justify-between gap-4 border-b border-background-200 pb-5">
            <h2
              id="hot-heading"
              className="font-heading text-2xl font-black text-foreground-950"
            >
              热读排行
            </h2>
            <span className="label-caps text-[11px] text-foreground-400">By Heat</span>
          </div>
          <div className="mt-2">
            {hot.map((article, index) => (
              <Reveal key={article.id} delay={index * 50}>
                <ArticleCard article={article} variant="compact" index={index} />
              </Reveal>
            ))}
          </div>
        </div>

        <aside className="lg:col-span-5">
          <div className="flex items-end justify-between gap-4 border-b border-background-200 pb-5">
            <h2 className="font-heading text-2xl font-black text-foreground-950">
              主题速览
            </h2>
            <Link
              to="/topics"
              className="whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
            >
              全部主题
            </Link>
          </div>
          <ul className="mt-4">
            {categories.map((cat) => {
              const count = getArticlesByCategory(cat.slug).length;
              return (
                <li key={cat.slug} className="border-b border-background-200 last:border-b-0">
                  <Link
                    to={`/topic/${cat.slug}`}
                    className="group flex items-center justify-between gap-4 py-4 cursor-pointer"
                  >
                    <span className="flex min-w-0 items-center gap-3">
                      <span className="label-caps w-16 shrink-0 font-heading text-[10px] text-secondary-500">
                        {cat.english}
                      </span>
                      <span className="min-w-0">
                        <span className="block font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                          {cat.name}
                        </span>
                        <span className="mt-1 line-clamp-1 block text-xs text-foreground-500">
                          {cat.description}
                        </span>
                      </span>
                    </span>
                    <span className="flex shrink-0 items-center gap-2 text-xs text-foreground-400">
                      {count} 篇
                      <i
                        className="ri-arrow-right-up-line transition-transform group-hover:-translate-y-0.5"
                        aria-hidden="true"
                      />
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </aside>
      </div>
    </section>
  );
}